/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum TransactionCompletionStatus {
    PREVENTED = 'PREVENTED',
    NO_COMPLETION_REQUIRED = 'NO_COMPLETION_REQUIRED',
    COMPLETED = 'COMPLETED',
    AWAITING_COMPLETION = 'AWAITING_COMPLETION'
}

